// extracted by mini-css-extract-plugin
export default {"navLinks":"AppNavContent-module__navLinks__GLZAF","navLink":"AppNavContent-module__navLink__IT9Th"};